/**
 * Aspect-tag chips a member can attach to a product review (multi-select),
 * alongside the star rating + comment + photos. Fixed set shared by the API
 * (validation) and both SPAs (chip UI). Codes are stored in
 * `product_reviews.aspect_tags`.
 */
export const REVIEW_ASPECT_TAGS = [
  { code: 'as_described', label: 'As described' },
  { code: 'good_quality', label: 'Good quality' },
  { code: 'value_for_money', label: 'Value for money' },
  { code: 'fast_delivery', label: 'Fast delivery' },
  { code: 'well_packaged', label: 'Well packaged' },
  { code: 'great_service', label: 'Great service' },
] as const;

export type ReviewAspectTag = (typeof REVIEW_ASPECT_TAGS)[number]['code'];

export const REVIEW_ASPECT_TAG_CODES = REVIEW_ASPECT_TAGS.map((t) => t.code) as ReviewAspectTag[];

export const REVIEW_ASPECT_TAG_LABEL: Record<string, string> = Object.fromEntries(
  REVIEW_ASPECT_TAGS.map((t) => [t.code, t.label]),
);

/** Max photos per review. */
export const REVIEW_MAX_PHOTOS = 5;
